import { red } from '@material-ui/core/colors';
import { createTheme, Theme } from '@material-ui/core/styles';
import { deDE } from '@material-ui/core/locale';

// Custom theme
const themeSettings = {
	palette: {
		primary: {
			main: '#1976d2'
		},
		secondary: {
			main: '#dc004e'
		},
		error: {
			main: red.A400
		}
	}
};

const theme = createTheme(themeSettings);

export const getTheme = (language: string): Theme => {
	if (language === 'de') {
		return createTheme(theme, deDE);
	}
	return theme;
};

export default theme;
